import React from 'react';
import {useTranslation} from 'react-i18next';
import TooltipWrapper from './common/TooltipWrapper';
import {ConnectionStatusNotificationType} from '../../incase-domain/connectionStatus';
import {TypedTranslation} from '../../i18n';

interface ConnectionStatusProps {
    type: ConnectionStatusNotificationType;
    message: TypedTranslation | null;
}

function ConnectionStatus({type, message}: ConnectionStatusProps): JSX.Element | null {
    const {t} = useTranslation();

    const component = (
        <div className={`c-connectionStatus c-connectionStatus--${type}`}>
            <div className="c-connectionStatus__dot" />
            <span>{t('connectionStatus.connection')}</span>
        </div>
    );

    if (message) {
        return (
            <TooltipWrapper id="connectionStatus-header" place="left" className="c-header__icon" content={<>{t(message)}</>}>
                {component}
            </TooltipWrapper>
        );
    }

    return component;
}

export default ConnectionStatus;
